// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const netWorth = "NetworthSummary__netWorth__jgL28";
export const pointing = "NetworthSummary__pointing__4btsZ";
export const regular = "400";
export const sans = "'sans'";
export const section = "NetworthSummary__section__LBmRr";
export const sections = "NetworthSummary__sections__ghe5r";
export const semibold = "600";
export const serif = "'serif'";